import { defineStore } from 'pinia';
import { api } from '@/services/http.service';
import { WhitelabelListItem } from '@/models/dictionary/whitelabel-list.model';
import { showErrorNotification } from '@/utils/show-notification.util';

interface WhitelabelListState {
  whitelabelList: WhitelabelListItem[];
  isWhitelabelListLoading: boolean;
}

export const useWhitelabelListStore = defineStore('WhitelabelListStore', {
  state: (): WhitelabelListState => ({
    whitelabelList: [],
    isWhitelabelListLoading: false,
  }),
  actions: {
    setWhitelabelListLoading(isLoading: boolean): void {
      this.isWhitelabelListLoading = isLoading;
    },
    getWhitelabelList(): Promise<WhitelabelListItem[]> {
      if (this.whitelabelList.length) {
        return Promise.resolve(this.whitelabelList);
      }

      this.setWhitelabelListLoading(true);

      return api.dictionary.getWhitelabelListRequest.perform()
        .then((whitelabelList: WhitelabelListItem[]) => {
          this.whitelabelList = whitelabelList;

          return whitelabelList;
        })
        .catch((error) => {
          showErrorNotification(error);

          return [];
        })
        .finally(() => {
          this.setWhitelabelListLoading(false);
        });
    },
  },
});
